const lightBg = '#ffffff',
primary = '#076973',
secondary = '#F5922C';

export default {
    primary: primary,
    secondary: secondary,
    themes: {
        light: {
            primary: primary,
            secondary: secondary,
            derasacolor: '#00235b',
            ebadge: '#ed5757',
            accent: '#82B1FF',
            error: '#ea4646', // #FF5252
            info: '#2196F3',
            success: '#13AC46',
            warning: '#FFC107',

            appbg: lightBg,
            phonebg: '#FFFFFF',
            navbarbg: '#fff',
            appmenubg: '#fafafa',
            surface: '#ffffff',
            surface2: '#f5f5f5',

            text: '#4e515f',
            muted: '#797979',
            tooltip: '#121212',
            snackbar: '#121212',

            'deep-purple': '#561bbe',
            'strong-text': '#000000',
            'border-color': '#e2e2e2',
        },
        dark: {
            primary: '#2eb6c4', 
            secondary: '#F5922C', 
            derasacolor: '#4169E1', 
            ebadge: '#FF6B6B', 
            accent: '#90CAF9', 
            error: '#FF5252', 
            info: '#64B5F6',
            success: '#4CAF50',
            warning: '#FFD54F',
            
            appbg: '#0f0f0f', 
            navbarbg: '#121212',
            appmenubg: '#141414',
            surface: '#171717',
            surface2: '#1e1e1e',
            
            text: '#E0E0E0',
            muted: '#9E9E9E',
            tooltip: '#424242',
            snackbar: '#323232',
            
            'deep-purple': '#8a6bbf',
            'strong-text': '#f2f2f2',
            'border-color': '#424242',
        }
    }
}